import React from 'react';
import 'stylesheets/components/account-settings-sidebar.scss';
import 'stylesheets/components/account-settings-tab-button.scss';
import 'stylesheets/components/account-settings-form-section.scss';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import LogoutButton from './LogoutButton';

type TabBarProps = RouteComponentProps & {
  children: React.ReactNode[];
  title?: string;
  showLogout?: boolean;
};

const TabBar = ({children, title, showLogout = true}: TabBarProps): React.ReactElement => (
  <div className="account-settings-container-tab-bar">
    {title && (
      <div className="account-settings-sidebar-title">
        <h1 className="account-settings-title">{title}</h1>
      </div>
    )}
    <div role="tablist">{children.filter(Boolean)}</div>
    {showLogout && (
      <div className="log-out-button-wrapper">
        <LogoutButton />
      </div>
    )}
  </div>
);

export default withRouter(TabBar);
